import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { FinanceDtoKeysEnum } from '@zaoblako/shared/modules/finance/enums/finance-dto-keys.enum';
import { DtoMessageEnum } from '@zaoblako/shared/common/enums/dto.message.enum';
import { ClientCheckerKeysEnum } from '@zaoblako/shared/modules/client/enums/client-checker-keys.enum';
import { entityLikeSchema } from '@zaoblako/shared/modules/serde/schemas/entity-like.schema';
import type { ContragentFindInterface } from '@zaoblako/shared/modules/client/dtos/contragent/contragent-find.dto';
import type { OperatorFindInterface } from '@zaoblako/shared/modules/finance/dtos/operator/operator-find.dto';
import type { OnlyIdRequiredInterface } from '@zaoblako/shared/common/interfaces/only-id-required.interface';

import * as yup from 'yup';

/** KKT create/update request body */
export interface KktFormInterface {
  /** Serial number */
  serialNumber: string;
  /** Registration number */
  regNumber: string;
  /** Fiscal storage */
  fnNumber: string;
  /** Registration address */
  address?: string;
  /** Kkt model */
  model?: string;
  /** Operator OFD */
  operator?: OnlyIdRequiredInterface<OperatorFindInterface>;
  /** Contragent */
  contragent: OnlyIdRequiredInterface<ContragentFindInterface>;
}

/** KKT create/update request body - DTO schema */
export const KktFormDto = SerdeDtoClass.create<KktFormInterface>(FinanceDtoKeysEnum.KKT_FORM_DTO, {
  serialNumber: {
    label: 'Серийный номер',
    serializer: yup.string().min(1, DtoMessageEnum.EMPTY_STRING),
  },
  regNumber: {
    label: 'Регистрационный номер',
    serializer: yup.string().min(1, DtoMessageEnum.EMPTY_STRING),
  },
  fnNumber: {
    label: 'Номер фискального накопителя',
    serializer: yup.string().min(1, DtoMessageEnum.EMPTY_STRING),
  },
  address: {
    optional: true,
    label: 'Адрес',
    serializer: yup.string(),
  },
  model: {
    optional: true,
    label: 'Модель',
    serializer: yup.string(),
  },
  operator: {
    optional: true,
    label: 'Оператор ОФД',
    serializer: entityLikeSchema,
  },
  contragent: {
    label: 'Контрагент',
    checkers: [ClientCheckerKeysEnum.CONTRAGENT_ASSERT_EXISTS_BY_DTO],
    serializer: entityLikeSchema,
  },
});
